import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconAddCircleSvg } from "./IconAddCircleSvg.mjs";
const IconAddCircle = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconAddCircleSvg, ...iconProps });
};
export {
  IconAddCircle
};
